import styled from 'styled-components';
import { Input, InputNumber, DatePicker, Form } from 'antd';

export const StyledInput = styled(Input)`
  width: 100%;
`;

export const StyledInputNumber = styled(InputNumber)`
  width: 100%;
`;
export const StyledDatePicker = styled(DatePicker)`
  width: 100%;
  background: white;
`;

export const StyledButtonFormItem = styled(Form.Item)`
  width: fit-content;
  margin-left: auto;
  .ant-btn-lg {
    margin-left: 20px;
  }
`;

export const StyledFlexDiv = styled.div`
  display: flex;
  justify-content: space-between;

  .ant-form-item {
    width: 45%;
  }
`;